export default __webpack_public_path__ + "24c5ac4aff3d1b09ccbee9da1a9e6453.jpg";